import { statusBadgeUi } from '@/components/Common/StatusBadge/StatusBadgeUi';
import { ColumnHeaderUi, PagingUi } from '@/components/TableData/TableDataUi';

export type CartsUi = {
  columnHeaders: ColumnHeaderUi[];
  items: CartItemUi[];
  paging?: PagingUi;
  isLoading?: boolean;
};

export type CartItemUi = {
  cartNumber: string;
  cartId: string;
  buyer: string;
  kam: string;
  dateUpdate: string;
  badgeStatus?: statusBadgeUi;
  totalAmount: string;
};

const tableHeaders = [
  {
    label: 'ID Carrito',
  },
  {
    label: 'Comprador',
  },
  {
    label: 'KAM',
  },
  {
    label: 'Fecha de actualización',
  },
  {
    label: 'Estatus',
  },
  {
    label: 'Total',
  },
  {
    label: '',
  },
];

export const initialState: CartsUi = {
  columnHeaders: tableHeaders,
  items: [],
};
